/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import * as ReactDOM from "react-dom";
import {
  Modal as ReactstrapModal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

export interface IModalProps {
  title: string;
  content: any;
  children?: any;
  actions?: any;
  className?: string;
  isOpen: boolean;
  container?: Element;
}

const Modal = (props: IModalProps) => {
  const ModalComponent = (
    <ReactstrapModal isOpen={props.isOpen} className={props.className}>
      <ModalHeader>{props.title}</ModalHeader>
      <ModalBody>{props.content}</ModalBody>
      <ModalFooter>{props.actions}</ModalFooter>
    </ReactstrapModal>
  );

  if (props.container) {
    return ReactDOM.createPortal(ModalComponent, props.container);
  }
  return ModalComponent;
};

export default Modal;
